import { render, staticRenderFns } from "./VehicleGroupForm.vue?vue&type=template&id=a88b12e8"
import script from "./VehicleGroupForm.vue?vue&type=script&lang=js"
export * from "./VehicleGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports